import { Component, OnInit, ChangeDetectorRef, Inject } from '@angular/core';
import * as firebase from 'firebase';
import { MatSnackBar } from '@angular/material';
import { Roles } from '../models/Roles';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
declare function require(name: string);
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
@Component({
  selector: 'app-allusers',
  templateUrl: './allusers.component.html',
  styleUrls: ['./allusers.component.scss']
})
export class AllusersComponent implements OnInit {
  allUsers: any[] = [];
  currentUser: any;
  userInfoDiag: any;
  deleteConfirm: any;
  roles = [Roles.client, Roles.clientAdmin, Roles.consultant];
  roleselected: string;
  currentSignedInUser: firebase.User;
  currentSignedInUserRole: string;
  searchCriteria: string;
  cachedUsers: any[] = [];
  constructor(public snackBar: MatSnackBar, public auths: AuthService, public router: Router, public ref: ChangeDetectorRef,
    public dialog: MatDialog, public dialogRef: MatDialogRef<AllusersComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.roleselected = '';
    this.searchCriteria = '';
  }

  ngOnInit() {
    this.auths.user.subscribe((user) => {
      if (!isNullOrUndefined(user)) {
        this.currentSignedInUser = user;
        const db = firebase.firestore();
        db.collection('users').where('uid', '==', user.uid).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if (doc.data().uid === user.uid) {
              this.currentSignedInUserRole = doc.data()['role'];
              this.getAllUsers();
            }
          });
        });
      }
    });
  }

  getAllUsers() {
    const db = firebase.firestore();
    db.collection('users').get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        if (doc.data()['role'] === Roles.consultant) {
          if (doc.data().createdBy && doc.data().createdBy === this.currentSignedInUser.uid ||
          this.currentSignedInUserRole === Roles.superUser) {
            this.allUsers.push(doc.data());
          }
        }
      });
      this.cachedUsers = this.allUsers;
      this.ref.detectChanges();
    });
  }

  openUser(user: any) {
    this.currentUser = user;
    const mdcDialog = require('@material/dialog');
    const MDCDialog = mdcDialog.MDCDialog;
    const MDCDialogFoundation = mdcDialog.MDCDialogFoundation;
    const util = mdcDialog.util;
    this.roleselected = user.role;
    this.userInfoDiag = new MDCDialog(document.querySelector('.userdiag'));
    this.userInfoDiag.open();
    this.ref.detectChanges();
  }

  openDeleteConfirmDialog() {
    const mdcDialog = require('@material/dialog');
    const MDCDialog = mdcDialog.MDCDialog;
    const MDCDialogFoundation = mdcDialog.MDCDialogFoundation;
    const util = mdcDialog.util;
    this.deleteConfirm = new MDCDialog(document.querySelector('.deleteconfirm'));
    this.deleteConfirm.open();
  }
  markDeleted(uid: string) {
    const db = firebase.firestore();
    let docID = '';
    db.collection('users').where('uid', '==', uid).get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        docID = doc.id;
      });
      this.updateDocDeleted(docID);
    });
  }

  updateDocDeleted(docID: string) {
    const db = firebase.firestore();

    db.collection('users').doc(docID).update({
      disabled: true
    }).then(() => {
      this.snackBar.open('User deleted', null, {
        duration: 2000,
      }).afterDismissed().subscribe(() => {
        window.location.reload();
      });
    });
  }

  updateRole(uid: string) {
    const db = firebase.firestore();
    let docID = '';
    db.collection('users').where('uid', '==', uid).get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        docID = doc.id;
      });
      this.updateRoleWithDocID(docID);
    });
  }

  updateRoleWithDocID(docId: string) {
    const db = firebase.firestore();

    db.collection('users').doc(docId).update({
      role: this.roleselected
    }).then(() => {
      this.snackBar.open('Role updated to ' + this.roleselected, null, {
        duration: 2500,
      }).afterDismissed().subscribe(() => {
        window.location.reload();
      });
    });
  }

  goBack() {
    window.history.back();
  }

  filterUsers() {
    document.getElementById('cancelSearch').style.display = 'block';
    const result = this.allUsers.filter(user => user.name.toLowerCase().includes(this.searchCriteria.toLowerCase()));
    this.allUsers = result;
  }

  cancelSearch() {
    document.getElementById('cancelSearch').style.display = 'none';
    this.allUsers = this.cachedUsers;
  }

}
